import React from 'react'

export default ({ node }) => <div>{node.extras.message}</div>



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/SendSmsMessage/SendSmsMessageDisplay.jsx